import React from 'react';
import './style.scss';

const NeedStatusDetails = ({ logins }) => {
    return(
        <div className="sub-content"> 
            <span>({logins.join(', ') })</span>
        </div>
    );
}

NeedStatusDetails.defaultProps = {
    logins: []
}

export { NeedStatusDetails };